import { Link } from "react-router-dom";

export function Footer() {
  return (
    <footer data-testid="main-footer" className="border-t border-[#222] bg-void">
      <div className="mx-auto max-w-[1600px] grid grid-cols-1 md:grid-cols-3 border-b border-[#222]">
        <div className="p-8 md:p-12 border-b md:border-b-0 md:border-r border-[#222]">
          <img src="/vp-logo-white.png" alt="Vice Performance" className="h-16 w-auto mb-6 opacity-90" data-testid="footer-logo" />
          <div className="text-xs uppercase tracking-[0.2em] text-[#9CA3AF] mb-4">// Engineering</div>
          <p className="font-grotesk text-lg text-[#FAFAFA] leading-snug">
            Uncompromising performance, reliability, and quality. Modern performance, built.
          </p>
        </div>
        <div className="p-8 md:p-12 border-b md:border-b-0 md:border-r border-[#222]">
          <div className="text-xs uppercase tracking-[0.2em] text-[#9CA3AF] mb-4">// Navigate</div>
          <div className="flex flex-col gap-3">
            <Link to="/vehicles" className="hover:text-neon transition-colors">Supported Vehicles</Link>
            <Link to="/performance" className="hover:text-neon transition-colors">Performance Parts</Link>
            <Link to="/tuning" className="hover:text-neon transition-colors">Tuning Request</Link>
            <Link to="/fabrication" className="hover:text-neon transition-colors">Fabrication Request</Link>
            <Link to="/faq" className="hover:text-neon transition-colors">FAQ</Link>
            <Link to="/resources" className="hover:text-neon transition-colors">Resources</Link>
            <Link to="/admin/login" className="text-[#9CA3AF] hover:text-neon transition-colors">Admin</Link>
          </div>
        </div>
        <div className="p-8 md:p-12">
          <div className="text-xs uppercase tracking-[0.2em] text-[#9CA3AF] mb-4">// Contact</div>
          <a href="mailto:info@viceperformance.com" className="block text-[#FAFAFA] hover:text-neon transition-colors mb-2">
            info@viceperformance.com
          </a>
          <p className="text-[#9CA3AF] text-sm">Monday – Friday / By appointment</p>
        </div>
      </div>
      <div className="mx-auto max-w-[1600px] px-5 md:px-10 py-6 flex flex-col md:flex-row justify-between gap-2 text-xs uppercase tracking-[0.2em] text-[#9CA3AF]">
        <span>© {new Date().getFullYear()} Vice Performance Engineering</span>
        <span className="text-neon">ViceTuned™</span>
      </div>
    </footer>
  );
}
